import React from 'react';

import { Flex, FormControl, FormErrorMessage, FormLabel, Heading } from '@chakra-ui/react';
import {
    AutoComplete,
    AutoCompleteInput,
    AutoCompleteItem,
    AutoCompleteList,
} from '@choc-ui/chakra-autocomplete';
import { Field, FieldProps } from 'formik';

import { CustomText } from '@components/Custom-text';

interface FormControlAutoCompleteFieldProps {
    name: string;
    label: string;
    placeholder: string;
    options: { key: string; value: string }[];
    isRequired?: boolean;
}

const FormControlAutoCompleteField: React.FC<FormControlAutoCompleteFieldProps> = ({
    name,
    label,
    placeholder,
    options,
    isRequired,
}) => (
    <Field name={name}>
        {({ field, form: { touched, errors, setFieldValue } }: FieldProps) => {
            const isInvalid = !!errors[field.name] && touched[field.name];
            return (
                <FormControl isInvalid={Boolean(isInvalid)}>
                    <Flex>
                        <FormLabel>
                            <Heading color="titleText" size="xs" as="h6">
                                {label}
                            </Heading>
                        </FormLabel>
                        {isRequired ? (
                            <Heading color="red" size="xs" ml={-2}>
                                *
                            </Heading>
                        ) : null}
                    </Flex>
                    <AutoComplete openOnFocus>
                        <AutoCompleteInput placeholder={placeholder} {...field} />
                        <AutoCompleteList>
                            {options.map(option => (
                                <AutoCompleteItem
                                    key={`option-${option.key}`}
                                    value={option.value}
                                    textTransform="capitalize"
                                    onClick={() => {
                                        setFieldValue(name, option.value);
                                    }}
                                >
                                    {option.value}
                                </AutoCompleteItem>
                            ))}
                        </AutoCompleteList>
                    </AutoComplete>
                    <FormErrorMessage>
                        <CustomText size="xs" color="red.500">
                            {String(errors[field.name])}
                        </CustomText>
                    </FormErrorMessage>
                </FormControl>
            );
        }}
    </Field>
);

export default FormControlAutoCompleteField;
